// Resize each frame around its own anchor, preserving spacing between elements.
// Heading ornaments keep their inner edge and vertical center beside the text.
export function resizeElement(node, scaleX, scaleY = scaleX, corner = "se", heading) {
  const w = node.w * scaleX, h = node.h * scaleY;
  const wing = node.headingWinglet;
  const angle = ((wing ? heading?.rotation : node.rotation) || 0) * Math.PI / 180;
  const cx = (w - node.w) / 2 * (wing ? (wing.side === "left" ? -1 : 1) : (corner.includes("e") ? 1 : -1));
  const cy = wing ? 0 : (h - node.h) / 2 * (corner.includes("s") ? 1 : -1);
  return {
    ...node, w, h,
    x: node.x + node.w / 2 + cx * Math.cos(angle) - cy * Math.sin(angle) - w / 2,
    y: node.y + node.h / 2 + cx * Math.sin(angle) + cy * Math.cos(angle) - h / 2,
  };
}
